import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Guest extends BaseModel {
  constructor (data, options) {
    super(data, options)
    this.test = 1
  }

  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'Guest'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      pin: null,
    }
  }
}
const servicePath = 'guests'
const servicePlugin = makeServicePlugin({
  Model: Guest,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
